import React, { useState, useEffect, useContext } from 'react';

//Import Css
import './CountdownTimer.css'



export function CountdownTimer({ duration }) {
  const [timeLeft, setTimeLeft] = useState(duration);

  useEffect(() => {
    let interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval); // detener el intervalo actual
          setTimeLeft(duration);   // reiniciar el contador
          interval = setInterval(() => { // crear uno nuevo
            setTimeLeft((prev) => (prev > 0 ? prev - 1 : duration));
          }, 1000);
          return duration;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [duration]);

  // cálculo de días, horas, minutos, segundos
  const days = Math.floor(timeLeft / (60 * 60 * 24));
  const hours = Math.floor((timeLeft % (60 * 60 * 24)) / (60 * 60));
  const minutes = Math.floor((timeLeft % (60 * 60)) / 60);
  const seconds = timeLeft % 60;

  return (
    <div className="countdown">
      <span className='text-time'>DD: {String(days).padStart(2, "0")}</span>{" "}
      <span className='text-time'>HH: {String(hours).padStart(2, "0")}</span>{" "}
      <span className='text-time'>MM: {String(minutes).padStart(2, "0")}</span>{" "}
      <span className='text-time'>SS: {String(seconds).padStart(2, "0")}</span>
    </div>
  );
}


